export const START_QUERY_GROUP_DIRSH = 'START_QUERY_GROUP_DIRSH';
export const QUERY_GROUP_DIRSH_SUCCESS = 'QUERY_GROUP_DIRSH_SUCCESS';
export const QUERY_GROUP_DIRSH_FAILURE = 'QUERY_GROUP_DIRSH_FAILURE';
export const INIT_QUERY_GROUP_DIRSH_ACTION_STATUS = 'INIT_QUERY_GROUP_DIRSH_ACTION_STATUS';

export const GROUP_DIRSH_QUERY_CHANGE_INPUT = 'GROUP_DIRSH_QUERY_CHANGE_INPUT';

export const SELECT_GROUP_DIRSH = 'SELECT_GROUP_DIRSH';

export const OPEN_ADD_OR_EDIT_GROUP_DIRSH_MODAL = 'OPEN_ADD_OR_EDIT_GROUP_DIRSH_MODAL';
export const RESET_ADD_OR_EDIT_GROUP_DIRSH_MODAL = 'RESET_ADD_OR_EDIT_GROUP_DIRSH_MODAL';
export const ADD_OR_EDIT_GROUP_DIRSH_CHANGE_INPUT = 'ADD_OR_EDIT_GROUP_DIRSH_CHANGE_INPUT';
export const START_SUBMIT_ADD_GROUP_DIRSH = 'START_SUBMIT_ADD_GROUP_DIRSH';
export const SUBMIT_ADD_GROUP_DIRSH_SUCCESS = 'SUBMIT_ADD_GROUP_DIRSH_SUCCESS';
export const SUBMIT_ADD_GROUP_DIRSH_FAILURE = 'SUBMIT_ADD_GROUP_DIRSH_FAILURE';
export const INIT_SUBMIT_ADD_GROUP_DIRSH_ACTION_STATUS = 'INIT_SUBMIT_ADD_GROUP_DIRSH_ACTION_STATUS';
export const START_SUBMIT_UPDATE_GROUP_DIRSH = 'START_SUBMIT_UPDATE_GROUP_DIRSH';
export const SUBMIT_UPDATE_GROUP_DIRSH_SUCCESS = 'SUBMIT_UPDATE_GROUP_DIRSH_SUCCESS';
export const SUBMIT_UPDATE_GROUP_DIRSH_FAILURE = 'SUBMIT_UPDATE_GROUP_DIRSH_FAILURE';
export const INIT_SUBMIT_UPDATE_GROUP_DIRSH_ACTION_STATUS = 'INIT_SUBMIT_UPDATE_GROUP_DIRSH_ACTION_STATUS';

export const OPEN_DEL_GROUP_DIRSH_MODAL = 'OPEN_DEL_GROUP_DIRSH_MODAL';
export const RESET_DEL_GROUP_DIRSH_MODAL = 'RESET_DEL_GROUP_DIRSH_MODAL';
export const START_SUBMIT_DEL_GROUP_DIRSH = 'START_SUBMIT_DEL_GROUP_DIRSH';
export const SUBMIT_DEL_GROUP_DIRSH_SUCCESS = 'SUBMIT_DEL_GROUP_DIRSH_SUCCESS';
export const SUBMIT_DEL_GROUP_DIRSH_FAILURE = 'SUBMIT_DEL_GROUP_DIRSH_FAILURE';
export const INIT_SUBMIT_DEL_GROUP_DIRSH_ACTION_STATUS = 'INIT_SUBMIT_DEL_GROUP_DIRSH_ACTION_STATUS';
